import axios from 'axios';
import { ACCESS_TOKEN, REFRESH_TOKEN } from './constants';
const apiEndpoint = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const refreshToken = localStorage.getItem(REFRESH_TOKEN);
                const res = await axios.post(`${apiEndpoint}/api/token/refresh/`, {
                    refresh: refreshToken,
                });

                if (res.status === 200) {
                    localStorage.setItem(ACCESS_TOKEN, res.data.access);
                    api.defaults.headers.common['Authorization'] = `Bearer ${res.data.access}`;
                    originalRequest.headers['Authorization'] = `Bearer ${res.data.access}`;
                    return api(originalRequest);
                }
            } catch (err) {
                localStorage.removeItem(ACCESS_TOKEN);
                localStorage.removeItem(REFRESH_TOKEN);
                window.location.href = "/login";
                return Promise.reject(err);
            }
        }
        if (error.response.status === 403) {
            window.location.href = "/settings";
            alert("Your subscription has expired, please renew it.");
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);
export default api;